<app-page-heading [heading]="'User Management'" [hasBackButton]="false"></app-page-heading>

<div class="page-container">
<ng-container *ngIf="hasPermissionToManageUsers; else noPermissions">
  <div class='header-container'>
    <div class="flex items-center">
      <mat-form-field class='filter-form-field'>
        <mat-label>Search User</mat-label>
        <input matInput
               type='text'
               (input)='onValueChanged($event.target.value)'>
      </mat-form-field>
      <mat-icon [matTooltip]="'Search by first name, last name or a username.'" class="info-icon">help_outline</mat-icon>

      <app-element-select class='filter-form-field'
                          displayLabel='Registration Status'
                          [defaultValue]="registrationStatusEnum.Approved"
                          [options]="Object.values(registrationStatusEnum)"
                          (selectionChanged)="onRegistrationStatusSelectionChanged($event)">
      </app-element-select>
    </div>

    <div class='header-spacer'></div>

    <div class="m-r-15 user-roles">
      <button color="primary" mat-raised-button
              (click)="onClickOpenUserRolesChart()">
        <mat-icon>help_outline</mat-icon>
        User Roles
      </button>
    </div>

    <div class="m-r-15">
      <button color="accent" mat-raised-button
              (click)="openUserDialog()">
        <mat-icon>add</mat-icon>
        Add User
      </button>
    </div>
  </div>

  <div *ngIf="isBusyCounter > 0" class="center-container">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="userDataSource && hasPermissionToManageUsers" class="mat-elevation-z8 table-container">

    <table mat-table multiTemplateDataRows [dataSource]="userDataSource"
           matSort (matSortChange)="sortData($event)">

      <ng-container *ngIf="hasPermissionToManageUsers" [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <mat-icon *ngIf="isEditIconVisible(row)"
                    class="table-icon" matTooltip="EDIT User"
                    (click)="onClickEditUser($event, row)">
                edit
          </mat-icon>
          <mat-icon *ngIf="isApproveIconVisible(row)"
                    class="table-icon" matTooltip="APPROVE User"
                    [ngClass]="{'disabled': isCurrentLoggedInUser(row)}"
                    (click)="onClickEditUser($event, row)">
                how_to_reg
          </mat-icon>
          <mat-icon *ngIf="isDeleteIconVisible(row)"
                    class="warn-icon" matTooltip="DELETE User"
                    [ngClass]="{'disabled': isCurrentLoggedInUser(row)}"
                    (click)="onClickDeleteUser($event, row)">
                delete
          </mat-icon>
          <mat-icon *ngIf="isResetPasswordIconVisible(row)"
                    class="table-icon" matTooltip="RESET User Password"
                    [ngClass]="{'disabled': isCurrentLoggedInUser(row)}"
                    (click)="onClickResetUserPassword($event, row)">
                lock_reset
          </mat-icon>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.UserId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>User ID</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.UserId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.FirstName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>First Name</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.FirstName]}}</td>
      </ng-container>


      <ng-container [matColumnDef]="tableColumns.LastName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Last Name</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.LastName]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.KeycloakId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Username</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.KeycloakId]}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsActive">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Active</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.IsActive] ? 'Y' : 'N'}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.EmailAddress">
        <th *matHeaderCellDef mat-header-cell>Email</th>
        <td *matCellDef="let row" mat-cell>{{row[tableColumns.EmailAddress]}}</td>
      </ng-container>

      <!-- Expanded Row -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" mat-cell [attr.colspan]="userDisplayedColumns.length">
          <div class="row-detail-container"
               [@detailExpand]="row == userExpandedRow ? 'expanded' : 'collapsed'">
            <b>Created By: </b>{{row.createdBy}}<br>
            <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row.updatedBy}}<br>
            <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
            <b>Approval Status: </b>{{row.requiresApproval === 1 ? registrationStatusEnum.Pending : registrationStatusEnum.Approved}}<br>
            <b>Linked Entity Code: </b>{{row.linkedEntityCode}}<br>
            <b>Roles: </b>
            <ng-container *ngIf="row.userRoles?.length; else noRoles; let idx=index">
              <ul>
                <li *ngFor="let role of row.userRoles;">{{role?.role_Name}}</li>
              </ul>
            </ng-container>
            <ng-template #noRoles>
              <h4 class="mat-primary-color center-align">
                There is no roles associated to this user
              </h4>
            </ng-template>
          </div>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="userDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: userDisplayedColumns;"
          class="row" [class.expanded-row]="userExpandedRow == row"
          (click)="userExpandedRow = userExpandedRow === row ? null : row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
    </table>

    <mat-paginator #userPaginator
                   [pageIndex]="0" [pageSize]="userTableControl.pageSize"
                   [pageSizeOptions]="userTableControl.pageSizeOptions"
                   [length]="userTableControl.length"
                   (page)="pageChanged($event)">
    </mat-paginator>

  </div>
  </ng-container>

  <ng-template #noPermissions>
    <div *ngIf="!hasPermissionToManageUsers" class="text-center mat-primary-color">
      <label class="column-label">You do not have sufficient permissions to view user data. Please contact an administrator for more assistance.</label>
    </div>
  </ng-template>
</div> <!--./page-container-->
